import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export function formatDate(dateString) {
  if (!dateString) return '';
  const date = new Date(dateString);
  return date.toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
  });
}

export function formatDateRange(startDate, endDate) {
  if (!startDate) return '';
  if (!endDate || startDate === endDate) return formatDate(startDate);
  
  const start = new Date(startDate);
  const end = new Date(endDate);
  
  if (start.getMonth() === end.getMonth() && start.getFullYear() === end.getFullYear()) {
    return `${start.toLocaleDateString('en-US', { month: 'short', day: 'numeric' })} - ${end.getDate()}, ${end.getFullYear()}`;
  }
  
  return `${formatDate(startDate)} - ${formatDate(endDate)}`;
}

export function getDaysUntil(dateString) {
  if (!dateString) return null;
  const date = new Date(dateString);
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  date.setHours(0, 0, 0, 0);
  const diff = Math.ceil((date - today) / (1000 * 60 * 60 * 24));
  return diff;
}

export function getStatusColor(status) {
  switch (status?.toUpperCase()) {
    case 'REGISTERED':
      return 'bg-emerald-100 text-emerald-700 border-emerald-200';
    case 'INTERESTED':
      return 'bg-amber-100 text-amber-700 border-amber-200';
    case 'UPCOMING':
      return 'bg-blue-100 text-blue-700 border-blue-200';
    default:
      return 'bg-slate-100 text-slate-700 border-slate-200';
  }
}

export function getLevelColor(level) {
  switch (level?.toLowerCase()) {
    case 'national':
      return 'bg-purple-100 text-purple-700';
    case 'state':
      return 'bg-blue-100 text-blue-700';
    case 'local':
      return 'bg-slate-100 text-slate-700';
    case 'joad':
    case 'youth':
      return 'bg-emerald-100 text-emerald-700';
    default:
      return 'bg-slate-100 text-slate-700';
  }
}

export function getOrgColor(org) {
  const colors = {
    'USAA': 'bg-red-100 text-red-700',
    'USAT': 'bg-indigo-100 text-indigo-700',
    'NFAA': 'bg-blue-100 text-blue-700',
    'TSAA': 'bg-orange-100 text-orange-700',
    'TFAA': 'bg-green-100 text-green-700',
    'ASA': 'bg-purple-100 text-purple-700',
    'IBO': 'bg-teal-100 text-teal-700',
  };
  return colors[org?.toUpperCase()] || 'bg-slate-100 text-slate-700';
}

export function truncateText(text, maxLength = 100) {
  if (!text || text.length <= maxLength) return text;
  return text.slice(0, maxLength) + '...';
}
